export const Roles = {
  IPL_USER: "IPL-User",
  IPL_INTL_RESOURCE_CREATOR: "IPL-INTL-Resource-Creator",
  IPL_INVITER: "IPL-Inviter",
  IPL_INTL_DOCS_VIEWER: "IPL-INTL-Docs-Viewer",
  IPL_INTL_ADMIN: "IPL-INTL-Admin",
};
